module.exports = __webpack_public_path__ + "img/step-half.caade84a.svg";